import { NavLink } from "react-router-dom";
import { Icon } from "../ui/Icon";

const LINKS = [
  { to: "/app", label: "工作台", icon: "layout" },
  { to: "/app/history", label: "我的记录", icon: "clock" },
  { to: "/app/account", label: "账户", icon: "user" },
];

export function BottomNav() {
  return <nav className="bottomnav" aria-label="移动主导航">
    {LINKS.map(link => <NavLink key={link.to} to={link.to} end={link.to === "/app"} className={({ isActive }) => isActive ? "active" : ""}>
      <span className="ic"><Icon name={link.icon} size={19} /></span>{link.label}
    </NavLink>)}
  </nav>;
}
